import { render, staticRenderFns } from "./CreateCoursewarePopup.vue?vue&type=template&id=1f99ed53"
import script from "./CreateCoursewarePopup.vue?vue&type=script&lang=js"
export * from "./CreateCoursewarePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports